import { inject, injectable } from "inversify";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { CustomURISchemeTypes, ICPLCPLCoreConnectClient } from "./api/cplapi/CPLAPI";

export interface ICPLCoreConnectService {
  saveCustomData(customURISchemeType: CustomURISchemeTypes, jsonDataModel: string): Promise<number>;
}

@injectable()
export class CPLCoreConnectService implements ICPLCoreConnectService {
  @inject(SERVICE_TYPES.CPLCPLCoreConnectClient) cplCoreConnectClient!: ICPLCPLCoreConnectClient;

  async saveCustomData(customURISchemeType: CustomURISchemeTypes, jsonDataModel: string): Promise<number> {
    return this.cplCoreConnectClient.saveCustomData(customURISchemeType, jsonDataModel);
  }
}
